import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export interface SubscriptionDeviceUsageProps {
  licensedDevices?: number;
  usedDevices?: number;
}

export function SubscriptionDeviceUsage({
  licensedDevices,
  usedDevices,
}: SubscriptionDeviceUsageProps): ReactElement {
  const { t } = useTranslation();
  const showWarning =
    licensedDevices !== undefined &&
    usedDevices !== undefined &&
    usedDevices > licensedDevices;
  const borderColor = showWarning ? 'border-color-red-500' : 'border-color-blue-500';
  const bgColor = showWarning ? 'bg-red-50' : 'bg-blue-50';
  const textColor = showWarning ? 'color-red-500' : 'color-blue-500';
  const overLimitAmount =
    usedDevices !== undefined && licensedDevices !== undefined
      ? usedDevices - licensedDevices
      : 0;
  return (
    <div
      className={`flex flex__dir--column gap-l border-solid ${borderColor} p-l border-radius-m ${bgColor}`}
      style={{ borderWidth: '2px' }}
    >
      <p className="font-weight-bold text-align-center">
        {t('subscription.deviceUsage.title')}
      </p>
      {showWarning && (
        <div className="flex flex__dir--row gap-s flex__ai--center color-red-700 flex__jc--center">
          <Icon name="alert" size={IconSizeClasses.XSmall} className="bg-red-500" />
          <p className="font-size-m">
            {t('subscription.deviceUsage.overLimit', { amount: overLimitAmount })}
          </p>
        </div>
      )}
      <div className="flex flex__dir--row gap-5xl flex__ai--center flex__jc--center">
        <div className="flex flex__dir--column gap-xs text-align-center p-s font-size-m">
          <span className={`font-weight-bold font-size-4xl ${textColor}`}>
            {usedDevices ?? '-'}
          </span>
          {t('subscription.deviceUsage.connected')}
        </div>
        <div className="border-solid border-color-gray-700 border-left-s border-right-s height-xxxl" />
        <div className="flex flex__dir--column gap-xs text-align-center p-s font-size-m">
          <span className="font-weight-bold font-size-4xl color-blue-500">
            {licensedDevices ?? '-'}
          </span>
          {t('subscription.deviceUsage.licensed')}
        </div>
      </div>
      <p className="font-size-s color-gray-800 text-align-center">
        {t('subscription.deviceUsage.countExplanation')}
      </p>
    </div>
  );
}
